import React from "react"

const CONNECTION_TYPES = ["promotes", "reinforces"]
export const connectionLabel = (type) => (type === "reinforces" ? "Reinforces" : "Promotes")

// Shared by every indicator card/checklist row across the wizard (ChecklistQuestion,
// KeepOrAcceptChecklist) so picking a connection type works and looks the same everywhere.
const ConnectionTypeToggle = ({
  code, value, disabled, onChange,
}) => (
  <span
    style={{
      display: "inline-flex",
      borderRadius: 4,
      overflow: "hidden",
      border: "1px solid #2f9e8f",
    }}
  >
    {CONNECTION_TYPES.map((type) => (
      <span
        key={type}
        role="button"
        tabIndex={0}
        onClick={(e) => onChange(code, type, e)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") onChange(code, type, e)
        }}
        style={{
          fontSize: 11,
          fontWeight: 600,
          color: value === type ? "#fff" : "#2f9e8f",
          background: value === type ? "#2f9e8f" : "#e4f2ef",
          padding: "2px 7px",
          cursor: disabled ? "default" : "pointer",
        }}
      >
        {connectionLabel(type)}
      </span>
    ))}
  </span>
)

export default ConnectionTypeToggle
